// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"bf5866b3","239":"76c91497","453":"97dbc49d","726":"63e59fed","732":"5befd295","806":"3f2d1164","977":"7064e3be"}[chunkId] + ".chunk.js";
};